import CustomButton from "components/CustomButton/CustomButton";
import DialogAlertSuccessNotifyNoOverlayClose from "components/DialogAlertNotify/DialogAlertSuccessNotify/DialogAlertSuccessNotifyNoOverlayClose";
import { Report } from "./styles";

const SyncAcadReinforceUnprocessedDialog = ({
    syncOfAcadReinforceUnprocessed,
    fillAcadReinforceList
}) => {
    const closeDialog = () => {
        syncOfAcadReinforceUnprocessed.dialogShow.toggle(false);
        fillAcadReinforceList();
    }
    return (
        <DialogAlertSuccessNotifyNoOverlayClose
            closeDialog={() => { /* Para que no se cierre el modal */}}
            variant="secondary"
            dialogShow={syncOfAcadReinforceUnprocessed.dialogShow}
            title="La sincronización ha terminado correctamente"
            contentComponent={<Content data={syncOfAcadReinforceUnprocessed.data}/>}>
            <CustomButton 
                text="Cerrar" 
                onClick={closeDialog}/>
        </DialogAlertSuccessNotifyNoOverlayClose>
    );
}

function Content({
    data
}) {
    if (!data) return;
    const {
        processed, 
        unprocessed,
        pending
    } = data;
    return (
        <Report className="list paragraph">
            <li>{processed} <b>procesado(s)</b></li>
            <li>{unprocessed} <b>no procesado(s)</b></li>
            <li>{pending} <b>pendiente(s)</b></li>
        </Report>
    );
}

export default SyncAcadReinforceUnprocessedDialog;